module.exports = __webpack_public_path__ + "static/media/Benchmarking.6a89dd3d.pdf";